import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import Home from "../src/components/Home";
import i18n from "../src/i18n";
import { HOST } from "../src/constants/host";
export var getStaticProps = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var t;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            t = i18n.t;
            return _context.abrupt("return", {
              props: {
                openGraphData: [{
                  property: 'og:url',
                  content: "".concat(HOST, "/"),
                  key: 'ogurl'
                }, {
                  property: 'og:title',
                  content: t('meta_common_title'),
                  key: 'ogtitle'
                }, {
                  property: 'og:description',
                  content: t('meta_common_description'),
                  key: 'ogdesc'
                }]
              }
            });

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getStaticProps() {
    return _ref.apply(this, arguments);
  };
}();
export default Home;